import { Trans } from '@lingui/macro'
import { Typography } from '@mui/material'
import Button, { ButtonProps } from '@mui/material/Button'
import { HELP_CASE_TYPES } from 'app/services/sfAuth/sfData/sfCaseTypes'
import { ReactElement, useState } from 'react'
import Inquiry from '../../../EgretLayout/SharedCompoents/Inquiry'
import './ContactUsButton.css'

const ContactUsButton = ({
  className,
  caseType = HELP_CASE_TYPES.CONTACT_US,
  ...props
}: ButtonProps & {
  caseType?: string | null
}): ReactElement => {
  const [inquiryOpen, openInquiry] = useState(false)

  return (
    <div>
      <Button
        color='primary'
        onClick={() => {
          openInquiry(true)
        }}
        variant='contained'
        {...props}
      >
        <Typography className={`contact-us-button-text ${className ?? ''}`}>
          <Trans>CONTACT_US_BUTTON</Trans>
        </Typography>
      </Button>
      <Inquiry
        selectCaseType={caseType == null}
        open={inquiryOpen}
        handleClose={() => openInquiry(false)}
        caseType={caseType}
      />
    </div>
  )
}

export default ContactUsButton
